/**
 * @generated SignedSource<<6365a44cf5b03e557be27d35f4fe6872>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SitesTimezoneQuery$variables = Record<PropertyKey, never>;
export type SitesTimezoneQuery$data = {
  readonly allTimeZones: ReadonlyArray<{
    readonly id: string;
    readonly name: string | null | undefined;
  }>;
};
export type SitesTimezoneQuery = {
  response: SitesTimezoneQuery$data;
  variables: SitesTimezoneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TimeZoneNode",
    "kind": "LinkedField",
    "name": "allTimeZones",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SitesTimezoneQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SitesTimezoneQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2177d87c3d5d177562ad19d1965346a4",
    "id": null,
    "metadata": {},
    "name": "SitesTimezoneQuery",
    "operationKind": "query",
    "text": "query SitesTimezoneQuery {\n  allTimeZones {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "957f11c127d108e5f7bfe1adb33dbf54";

export default node;
